'use strict';

function EMTRequestProcessing() {
  this.id = null;
  this.node = null;
  this.extends = [EMTController, _Paths];
  this._analytics = new Analytics();
  this._history = new History();

  this.timeOutDuration = 30000; // 30 sec

  this.init = function () {
    var _this = this;

    this._super();

    $.when(this.emtRequestModelPromise).then(function () {
      _this.emtRequestId = _this.getEmtRequestId();
      _this.pollEmtStatus(_this.emtRequestId, _this._routeToNextStep.bind(_this));
    });

    this._pollingTimer = setTimeout(function () {
      _this.stopPollEmtStatus();
      return _this._history.goToUrl(_this.paths.emt[_this.emtRequestProduct].status);
    }, this.timeOutDuration);
  };

  this.initAllReady = function () {};

  this.initPage = function () {};

  this._routeToNextStep = function () {
    var emtStatus = this.getEmtStatus();
    var url = '';

    switch (emtStatus) {
      case 'FAILED':
        url = this.paths.emt[this.emtRequestProduct].status;
        break;
      case 'DEPOSIT_COMPLETE':
      case 'COMPLETED':
        url = this.paths.emt[this.emtRequestProduct].complete;
        break;
      default:
    }

    if (url) {
      this.stopPollEmtStatus();
      this._history.goToUrl(url);
    }
  };

  this.destroy = function () {
    this.stopPollEmtStatus();

    if (this._pollingTimer) clearTimeout(this._pollingTimer);
  };
}